/*
 * @Description: 入口文件
 * @Author: juanjuanhui
 * @Date: 2023-12-12 20:50:40
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-05-16 21:48:13
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from '@/api/api'
import * as echarts from 'echarts'
import "@/utils/tianditu.js";
import '@/styles/reset.css'
import '@/styles/common.scss'
import './styles/global.scss'
import "./assets/iconfont/iconfont.css";
// import 'amfe-flexible'
import 'lib-flexible'
// import VConsole from "vconsole";

// if (process.env.NODE_ENV === "development") {
//   new VConsole();
// }
Vue.prototype.$echarts = echarts
Vue.prototype.$http = http
Vue.config.productionTip = false
Vue.prototype.$EventBus = new Vue();
// import { systemType } from "utils/mixins";
// Vue.mixin(systemType);
//按需引入UI组件
import { vant } from '@/utils/vant.config.js'
Vue.use(vant)
import SliderVerify from "dt-slider-verify";
Vue.use(SliderVerify)
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
